import React from 'react';
import { TaskList } from '@sharefiledev/icons';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { AsyncSelectFolderModal, taskAggregatorModals } from './overlays';
import { AsyncBlockDevelopmentPage } from './Pages';
import { addBlocks } from './SolutionViewEngine/Blocks';
import { configureHttp } from './TaskAggregatorHttp';
import { TranslatedString } from './utils/TranslatedString';

export function setup(app: PiletApi) {
	addBlocks(app);

	app.registerModal(
		taskAggregatorModals.selectFolder,
		({ ...props }) => <AsyncSelectFolderModal {...props} piletApi={app} />,
		{
			modalProps: {
				title: <TranslatedString localizationKey="selectFolderModal.saveAllToFolder" />,
				destroyOnClose: true,
				footer: null,
			},
		}
	);

	const AsyncLazyTaskListUnresolved = React.lazy(
		() => import('./components/TaskListUnresolved')
	);

	app.registerExtension(
		'urn:sfextslot:task-aggregator-pilet:unresolved-tasks-count',
		({ params }) =>
			(<AsyncLazyTaskListUnresolved piletApi={app} params={params} />) as any
	);

	const smokeTestCustomers = [
		'pilet-tests.sharefiletest.com',
		'pilet-tests.sharefilestaging.com',
		'pilet-tests.sharefile.com',
	];

	if (
		process.env.NODE_ENV === 'development' ||
		smokeTestCustomers.includes(location.hostname)
	) {
		app.registerPage('/task-aggregator-block-development', () => (
			<AsyncBlockDevelopmentPage piral={app} params={{}} />
		));

		app.sf.registerLeftNavComponent({
			href: '/task-aggregator-block-development',
			title: () => 'Task Aggregator Block Dev',
			icon: TaskList,
			weight: 50,
		});

		if (typeof app.meta.config.apiOrigin === 'string') {
			configureHttp(config => (config.origin = app.meta.config.apiOrigin));
		}
	}
}
